// plugins/event-bus.client.ts - 客户端事件总线插件
// 用于组件间通信，替代 Vue 3 移除的全局事件总线

import mitt, { type Emitter } from 'mitt'

type ApplicationEvents = {
  'auth-modal-closed': void
  // 未来可以添加更多事件类型
}

export default defineNuxtPlugin(() => {
  const emitter: Emitter<ApplicationEvents> = mitt<ApplicationEvents>()

  return {
    provide: {
      event: emitter
    }
  }
})

